import React from 'react';
import styles from './Conditions.module.scss';
import Military from './../../images/military.jpg'
import {ReactComponent as Passport} from "./../../images/passport.svg";
import {ReactComponent as Media} from "./../../images/media.svg";
import {ReactComponent as Award} from "./../../images/award-04.svg";
import {ReactComponent as Users} from "./../../images/users.svg";
import {ReactComponent as Social} from "./../../images/social.svg";

const Conditions = () => {
    return (
        <div className={styles.container}>
            <div className={styles.textBlock}>
                <h2 className={styles.title}>УСЛОВИЯ УЧАСТИЯ В ПРОЕКТЕ</h2>
            </div>
            <div className={styles.conditionsCard}>
                <img className={styles.img} src={Military} alt="Военный"/>
                <div className={styles.textContainer}>
                    <div className={styles.listBlock}>
                        <div className={styles.textSpan}>
                            <Passport/>
                            <p>Гражданство Российской Федерации</p>
                        </div>

                        <div className={styles.textSpan}>
                            <Media/>
                            <p>Участие в СВО</p>
                        </div>

                        <div className={styles.textSpan}>
                            <Award/>
                            <p>Высшее образование</p>
                        </div>

                        <div className={styles.textSpan}>
                            <Users/>
                            <p>Опыт управления людьми</p>
                        </div>

                        <div className={styles.textSpan}>
                            <Social/>
                            <p>Отсутствие судимостей</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default Conditions;